import style from './style';
import compose from './compose';
export var color = style({
  prop: 'color',
  themeKey: 'palette'
});
export var bgcolor = style({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = compose(color, bgcolor);
export default palette;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/system/esm/palette.js
// module id = 647
// module chunks = 0